import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';

const CookiePolicyModal = ({ show, onHide }) => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (show) {
      const lang = i18n.language || 'fr';
      fetch(`/cookie_${lang}.md`)
        .then((response) => {
          if (!response.ok) throw new Error("Fichier introuvable");
          return response.text();
        })
        .then((text) => setContent(text))
        .catch(() => {
          fetch(`/cookie_en.md`)
            .then((res) => res.text())
            .then((text) => setContent(text))
            .catch((err) => setContent("Erreur de chargement de la politique des cookies."));
        });
    }
  }, [show, i18n.language]);

  return (
    <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('cookie_policy.title', 'Politique relative aux cookies')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto', textAlign: 'left' }}>
        <div className="text-start markdown-body">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          {t('common.close', 'Fermer')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CookiePolicyModal;
